import { post } from '@/api/core'

import type { MemberMyInfoRes } from './types'

export function member_my_info () {
  return post<MemberMyInfoRes>('member_my_info')
}
